module.exports = __webpack_public_path__ + "static/media/resume-pie.a1c48ecc.svg";